// Use react-sounds built-in playSound function
import { playSound as reactPlaySound } from 'react-sounds'
import { useSettingsStore } from './store/settingsStore'

// Volume multiplier for auction win sound (plays quieter than other SFX)
const AUCTION_WIN_VOLUME_MULTIPLIER = 0.25

/**
 * Helper to play a sound with error handling and SFX volume applied
 * Only plays if SFX is enabled in settings
 */
function playSoundWithVolume(soundId: string, volumeMultiplier: number = 1): void {
  try {
    const { sfxEnabled, sfxVolume } = useSettingsStore.getState().audio
    if (!sfxEnabled) return

    const finalVolume = sfxVolume * volumeMultiplier
    reactPlaySound(soundId, { volume: finalVolume })
  } catch (error) {
    // Silently fail - audio errors shouldn't break gameplay
    console.warn('[GameSounds] Failed to play sound:', soundId, error)
  }
}

/**
 * Standalone game sound player - uses react-sounds internally
 * Works from anywhere including non-React code (gameStore actions)
 *
 * All sounds:
 * - Respect the user's SFX enabled setting from preferences
 * - Respect the user's SFX volume setting from preferences
 * - Have error handling to prevent breaking gameplay
 */
export const GameSounds = {
  playCardDeal: () => playSoundWithVolume('ui/panel_expand'),
  playCardPlay: () => playSoundWithVolume('ui/button_soft'),
  playPass: () => playSoundWithVolume('ui/item_deselect'),
  playRoundEnd: () => playSoundWithVolume('ui/success_chime'),
  playGameEnd: () => playSoundWithVolume('ui/success_chime'),
  playAuctionWin: () => playSoundWithVolume('ui/success_bling', AUCTION_WIN_VOLUME_MULTIPLIER),
}
